import React from "react";
import styled from "styled-components";
import arrow from "../assets/arrow.svg";
import icon1 from "../assets/ic_process_01.svg";
import icon2 from "../assets/ic_process_02.svg";
import icon3 from "../assets/ic_process_03.svg";
import icon5 from "../assets/ic_process_05.svg";
import shape1 from "../assets/page4shape1.png";
import shape2 from "../assets/page4shape2.png";
import useInViewAnimation from "../hooks/useInViewAnimation";
import { motion } from "framer-motion";

function Page4Pc() {
  const variant = (i) => {
    return {
      visible: {
        opacity: 1,
        transition: { duration: 0.7, delay: i * 0.2 },
      },
      hidden: { opacity: 0 },
    };
  };
  const [ref1, control1] = useInViewAnimation(0.7);
  return (
    <MainContainer id="process">
      <Title initial="hidden" variants={variant(0)} animate={control1}>
        js lap만의 남다른 프로세스
      </Title>
      <SubTitle initial="hidden" variants={variant(0)} animate={control1}>
        평균 <b>10일동안</b> 촬영 가능한 완성샘플을 보여드릴 수 있습니다
      </SubTitle>
      <Row ref={ref1}>
        <Column initial="hidden" variants={variant(0)} animate={control1}>
          <Icon src={icon1} />
          <ColumnTitle>디자인 확정</ColumnTitle>
          <ColumnDesc>
            미팅을 통한 만들고자 하는
            <br />
            디자인을 확정합니다
          </ColumnDesc>
        </Column>
        <Arrow
          src={arrow}
          initial="hidden"
          variants={variant(0)}
          animate={control1}
        />
        <Column initial="hidden" variants={variant(1)} animate={control1}>
          <Icon src={icon2} />
          <ColumnTitle>3D 모델링</ColumnTitle>
          <ColumnDesc>
            3D 프로그램을 이용한
            <br />
            모델링 후 출력합니다
          </ColumnDesc>
        </Column>
        <Arrow
          src={arrow}
          initial="hidden"
          variants={variant(1)}
          animate={control1}
        />
        <Column initial="hidden" variants={variant(2)} animate={control1}>
          <Icon src={icon3} />
          <ColumnTitle>원본추출</ColumnTitle>
          <ColumnDesc>
            실버로 주물 생성 후<br />
            고무가다를 제작합니다
          </ColumnDesc>
        </Column>
        <Arrow
          src={arrow}
          initial="hidden"
          variants={variant(2)}
          animate={control1}
        />
        <Column initial="hidden" variants={variant(3)} animate={control1}>
          <Icon src={icon5} />
          <ColumnTitle>샘플완성</ColumnTitle>
          <ColumnDesc>
            샘플 출력 후<br />
            완성품을 제작합니다
          </ColumnDesc>
        </Column>
      </Row>
      <Shape1Container>
        <Shape1 src={shape1} />
      </Shape1Container>
      <Shape2Container>
        <Shape2 src={shape2} />
      </Shape2Container>
    </MainContainer>
  );
}

export default Page4Pc;
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  background: linear-gradient(90deg, #fb67ae 0%, #ff8541 76.56%);
  z-index: 1;
  overflow: hidden;
  position: relative;
`;
const Title = styled(motion.p)`
  color: #fff;
  font-family: Pretendard;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
  line-height: 60px; /* 120% */
  margin-top: 150px;
`;
const SubTitle = styled(motion.p)`
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px; /* 150% */
  margin-top: 30px;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  margin-top: 140px;
  margin-bottom: 400px;
  @media screen and (max-width: 1440px) {
    scale: 0.8;
    margin-bottom: 350px;
  }
  @media screen and (max-width: 1200px) {
    scale: 0.68;
    margin-bottom: 250px;
  }
`;
const Column = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Arrow = styled(motion.img)`
  width: 42px;
  height: 203.169px;
  flex-shrink: 0;
  margin: 0px 65px;
`;
const Icon = styled.img`
  width: 100px;
  height: 100px;
`;
const ColumnTitle = styled.p`
  color: #fff;
  font-family: Pretendard;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 44px; /* 129.412% */
  margin-top: 31px;
`;
const ColumnDesc = styled.p`
  width: 230px;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px; /* 163.636% */
  margin-top: 12px;
`;
const Shape1Container = styled.div`
  position: absolute;
  left: 0;
  transform: translate(-80px, 700px);
  @media screen and (max-width: 1440px) {
    transform: translate(-80px, 650px);
  }
  @media screen and (max-width: 1200px) {
    transform: translate(-80px, 570px);
  }
`;
const Shape1 = styled.img`
  width: 307.567px;
  height: 277.936px;
  transform: rotate(62.447deg);
  flex-shrink: 0;
`;
const Shape2Container = styled.div`
  position: absolute;
  right: 0;
  transform: translate(-150px, -70px);
`;
const Shape2 = styled.img`
  width: 185.673px;
  height: 211.634px;
  transform: rotate(-12.504deg);
  flex-shrink: 0;
`;
